const initialState = {
  isAdmin: false,
  organization: {
    name: '',
    registeredTime: new Date().getTime(),
    registrationStatus: 'TRIAL',
  },
  accounts: [],
  isShowSubmitAddUserResult: false,

  addNewAccountBegin: false,
  addNewAccountFailure: false,
  addNewAccountSuccess: false,

  updateUserAccountBegin: false,
  updateUserAccountFailure: false,
  updateUserAccountSuccess: false,

  deleteUserAccountBegin: false,
  deleteUserAccountFailure: false,
  deleteUserAccountSuccess: false,
};

export default initialState;



// WEBPACK FOOTER //
// ./src/features/user-management/redux/initialState.js